<template>
  <div :class="['mainContent', !currentTheme ? 'innovative' : 'criticize']">
    <div class="header" :style="{'backgroundImage': 'url(' + themeList[currentTheme]['--header-bg-img'] + ')'}">
      <img
        :src="themeList[currentTheme]['--header-logo']"
        alt=""
        class="icon"
      />
      <div class="detail">
        <div class="name">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff286dd94a/228576436.png"
            alt=""
          />
          <span>{{ name }}</span>
        </div>
        <div class="elapsedTime">
          <span>总时长:</span>
          <div class="progress">
            <el-progress
              :color="themeList[currentTheme]['--progress-bg-color']"
              :show-text="false"
              :percentage="percentage"
            ></el-progress>
            <div class="pastTime" :style="{left, 'backgroundImage': 'url(' + themeList[currentTheme]['--progress_tip'] + ')'}">
              <span>{{ minute }}分钟</span>
            </div>
          </div>
          <div class="time">{{$route.name === 'examInnovationSteer' ? '30分钟':'90分钟'}}</div>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      percentage: 0,
      time: 0,
      minute: 0,
      name: '',
      left: 0,
      themeList: [
        {
          '--progress-bg-color': '#667C6B',
          '--progress-bg-img': 'url(' + require('@/assets/exam/theme0/progress_tip.png') + ')',
          '--header-logo': require('@/assets/exam/theme0/header_logo.png'),
          '--header-bg-img': require('@/assets/exam/theme0/header_bg.png'),
          '--progress_tip': require('@/assets/exam/theme0/progress_tip.png'),
        },
        {
          '--progress-bg-color': '#956D88',
          '--progress-bg-img': 'url(' + require('@/assets/exam/theme1/progress_tip.png') + ')',
          '--header-logo': require('@/assets/exam/theme1/header_logo.png'),
          '--header-bg-img': require('@/assets/exam/theme1/header_bg.png'),
          '--progress_tip': require('@/assets/exam/theme1/progress_tip.png'),
        },
      ],
      currentTheme: 0,
    };
  },
  created: function() {
    const timer = setInterval(() => {
      if (sessionStorage.examTime) {
        const cha = (new Date().getTime() - sessionStorage.examTime) / 1000
        const repair1 = Math.floor(cha / 60) <= 9 ? '0' : ''
        const repair2 = cha % 60 <= 9 ? '0' : ''
        this.time = repair1 + Math.floor(cha / 60) + ':' + repair2 + Math.floor(cha % 60);
        this.percentage = this.$route.name === 'examInnovationSteer' ? Math.min(cha / 60 / 30 * 100, 100) : Math.min(cha / 60 / 90 * 100, 100);
        this.left = this.percentage + '%'
        // console.log(this.left)
        if (this.percentage === 100) {
          clearInterval(timer)
        }
        this.minute = this.$route.name === 'examInnovationSteer' ? Math.min(30, Math.floor(cha / 60)) : Math.min(90, Math.floor(cha / 60))
      } else {
        sessionStorage.examTime = new Date().getTime()
        this.time = '00:00';
        this.percentage = 0;
      }
      this.$store.commit('setMinute', this.minute)
    }, 1000);
    this.name = JSON.parse(sessionStorage.userInfo).stu_name
    this.initTheme()
  },
  methods: {
    initTheme() {
      const subjectPath = this.$route.fullPath
      const theme0 = ['innovation', 'controller', 'stormwater', 'cosmodom', 'birdFlu', 'sprout']
      if (theme0.findIndex(item => subjectPath.indexOf(item) > -1) > -1) {
        this.changeTheme(this.themeList[0])
        this.currentTheme = 0
      } else {
        this.changeTheme(this.themeList[1])
        this.currentTheme = 1
      }
    },
    changeTheme(theme) {
      for (const key in theme) {
        if (Object.hasOwnProperty.call(theme, key)) {
          const element = theme[key];
          document.documentElement.style.setProperty(key, element);
        }
      }
    },
  },
  mounted() {
    // var map = new BMap.Map("container");
    // var point = new BMap.Point(116.404, 39.915);
  }
};
</script>
<style lang="less">
.mainContent {
  background: #ebebeb;
  width: 100%;
  height: 100vh;
  padding-top: 0 !important;
  .header {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 0 27px;
    box-sizing: border-box;
    background-size: 100% 100%;
    span,
    div {
      font-size: 14px;
      font-weight: 600;
      color: #35383e;
      line-height: 1;
    }
    > img {
      height: 38px;
    }
    .detail {
      display: flex;
      align-items: center;
      .name {
        display: flex;
        align-items: center;
        > img {
          width: 18px;
          margin-right: 6px;
        }
        padding-right: 116px;
      }
      .time {
        padding-right: 116px;
      }
      .elapsedTime {
        display: flex;
        .progress {
          width: 270px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          position: relative;
          > div:nth-child(1){
            width: 100%;
          }
          .pastTime{
            position: absolute;
            margin-left: -25px;
            top: 12px;
            background-image: var(--progress-bg-img);
            background-size: 100% 100%;
            width: 52px;
            height: 25px;
            text-align: center;
            span{
              font-size: 24px;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 28px;
              transform: scale(0.5);
              display: block;
              position: relative;
              width: 200%;
              margin-left: -25px;
              // padding: 3px 0px;
            }
          }
        }
        .time {
          color: #696969;
          padding-left: 12px;
          font-size: 14px;
        }
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100vh - 64px);
    background: #fff;
    border-top: 12px solid #f7f7f7;
  }
}
.innovative .el-progress-bar__outer {
    background-color: #D2E5D4
  }
  .criticize .el-progress-bar__outer {
    background-color: #DAD2E5
  }
</style>
<style>
#newBridge {
  display: none !important;
}
</style>
